<template>
  <div class="advertisement-content">
    <div class="advertisement-content-list">
      <div
        class="advertisement-content-list-item"
        v-for="(item, index) in dataList"
        :key="index"
      >
        <div class="advertisement-content-list-item-top">
          <img src="../assets/default.png" alt="" class="default" />
          <span>{{ item.creatorName }}</span>
          <!-- <el-tag :color="item.userType == 1?'#f56c6c':'#f56c6c'">{{item.userType == 1?"个人":"企业"}}</el-tag> -->
          <img
            src="../assets/company.png"
            alt=""
            class="type"
            v-if="item.userType == 2"
          />
          <img src="../assets/person.png" alt="" class="type" v-else />
        </div>
        <h1>{{ item.projectName }}</h1>
        <h2>{{ item.projectDescribe }}</h2>
        <h3>预算：{{ item.projectSpendStr }}</h3>
        <h4>期望交付周期：{{ item.expectDay }}天</h4>
        <em></em>
        <div
          class="advertisement-content-list-item-detail"
          @click="handleDetail(item)"
        >
          查看详情
        </div>
      </div>
    </div>
    <el-pagination
      style="text-align: right"
      @current-change="handleCurrentChange"
      layout="prev, pager, next"
      class="pagination"
      :page-size="pageSize"
      :total="total"
      v-if="total > 0"
    >
    </el-pagination>
  </div>
</template>

<script>
import { prjIntroGetAuditeProjectList } from "../utils/records";
export default {
  data() {
    return {
      dataList: [],
      total: 0,
      pageNo: 1,
      pageSize: 6,
    };
  },
  props: {
    type: {
      type: String,
    },
  },
  methods: {
    // 分页
    handleCurrentChange(page) {
      this.pageNo = page;
      this.getList();
    },
    handleDetail(item) {
      this.$router.push({ path: "/recordsDetail", query: { item: encodeURIComponent(JSON.stringify(item)) } });
    },
    getList() {
      let data = {
        currentPage: this.pageNo,
        pageSize: this.pageSize,
        type: this.type,
        status: 0,
      };
      prjIntroGetAuditeProjectList(data).then((res) => {
        // console.log('@',res);
        if (res.data.code == 200) {
          this.$nextTick(() => {
            this.dataList = res.data.data;
            this.total = res.data.total;
          });
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
  },
  activated() {
    this.getList();
  },
};
</script>

<style scoped lang="less">
.fontdemo(@size,@family,@weight,@color) {
  font-size: @size;
  font-family: @family;
  font-weight: @weight;
  color: @color;
}
.advertisement {
  &-content {
    width: 100%;
    padding: 52px 190px 114px;
    box-sizing: border-box;
    background: url("../assets/cover.png") no-repeat;
    background-size: cover;
    &-list {
      width: 100%;
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      &-item {
        width: 32%;
        box-sizing: border-box;
        padding: 40px 44px;
        text-align: left;
        background: #ffffff;
        margin-bottom: 52px;
        margin-right: 2%;
        cursor: pointer;
        &-top {
          display: flex;
          align-items: center;
          .default {
            width: 60px;
            height: 60px;
            margin-right: 16px;
          }
          .type {
            width: 53px;
            margin-left: 10px;
            margin-top: 3px;
          }
          span {
            .fontdemo(20px, "PingFangSC,PingFang SC", 600, #000000);
          }
        }
        h1 {
          .fontdemo(22px, "PingFangSC,PingFang SC", 600, #000000);
          margin: 20px 0 20px;
          overflow: hidden;
          text-overflow: ellipsis;
          -webkit-line-clamp: 1;
          -webkit-box-orient: vertical;
          display: -webkit-box;
          width: 70%;
        }
        h2 {
          .fontdemo(20px, "PingFangSC,PingFang SC", 400, rgba(0,0,0,0.85));
          overflow: hidden;
          text-overflow: ellipsis;
          -webkit-line-clamp: 8;
          -webkit-box-orient: vertical;
          display: -webkit-box;
          height: 205px;
        }
        h3 {
          .fontdemo(18px, "PingFangSC,PingFang SC", 400, #566781);
          margin: 27px 0 8px;
        }
        h4 {
          .fontdemo(18px, "PingFangSC,PingFang SC", 400, #566781);
        }
        em {
          width: 100%;
          height: 1px;
          border-bottom: 1px solid #e7e7e7;
          display: block;
          margin: 25px 0 20px;
        }
        &-detail {
          width: 110px;
          height: 40px;
          background: #4787f0;
          border-radius: 8px;
          .fontdemo(16px, "PingFangSC,PingFang SC", 500, #FFFFFF);
          display: flex;
          justify-content: center;
          align-items: center;
          margin-left: auto;
        }
      }
      :nth-child(3n) {
        margin-right: 0;
      }
    }
  }
}
.pagination {
  margin: 10px auto 0px;
}
/deep/ .el-pager li {
  width: 40px;
  height: 40px;
  line-height: 40px;
  border-radius: 3px;
  font-size: 14px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.9);
  margin: 0 13px;
}
/deep/ .el-pager .active {
  background: #0052d9;
  font-size: 14px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  color: rgba(255, 255, 255, 0.9);
}
/deep/ .btn-prev {
  width: 40px;
  height: 40px;
}
/deep/ .btn-next {
  width: 40px;
  height: 40px;
}
</style>
